module.exports = __webpack_public_path__ + "static/media/display-3@768.b92d48c7.png";